const FAVORITES_KEY = 'cooksy-favorites';

// Get all favorites from localStorage
export function getFavorites() {
  try {
    const favorites = localStorage.getItem(FAVORITES_KEY);
    return favorites ? JSON.parse(favorites) : [];
  } catch (error) {
    console.error('Error getting favorites:', error);
    return [];
  }
}

// Add a meal to favorites
export function addFavorite(meal) {
  try {
    const favorites = getFavorites();
    
    // Check if meal is already in favorites
    if (favorites.find(fav => fav.idMeal === meal.idMeal)) {
      return favorites; // Already exists
    }
    
    const newFavorites = [...favorites, meal];
    localStorage.setItem(FAVORITES_KEY, JSON.stringify(newFavorites));
    
    return newFavorites;
  } catch (error) {
    console.error('Error adding favorite:', error);
    return getFavorites();
  }
}

// Remove a meal from favorites by ID
export function removeFavorite(id) {
  try {
    const favorites = getFavorites();
    const newFavorites = favorites.filter(fav => fav.idMeal !== id);
    
    localStorage.setItem(FAVORITES_KEY, JSON.stringify(newFavorites));
    
    return newFavorites;
  } catch (error) {
    console.error('Error removing favorite:', error);
    return getFavorites();
  }
}

// Check if a meal is in favorites
export function isFavorite(id) {
  try {
    const favorites = getFavorites();
    return favorites.some(fav => fav.idMeal === id);
  } catch (error) {
    console.error('Error checking favorite:', error);
    return false;
  }
}

// Toggle favorite status
export function toggleFavorite(meal) {
  if (isFavorite(meal.idMeal)) {
    return removeFavorite(meal.idMeal);
  } else {
    return addFavorite(meal);
  }
}